import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import 'webgl-lint'
import { AppView } from './AppView.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppView />
  </StrictMode>
)
